import { render, staticRenderFns } from "./AddPinjaman.vue?vue&type=template&id=0873076f&"
import script from "./AddPinjaman.vue?vue&type=script&lang=js&"
export * from "./AddPinjaman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports